<template>
    <div>
        <Steps :current-page="3"></Steps>
        <div class="container container-xs">
            <div class="text-center heading-wrapper">
                <span class="heading">{{ $t('my_shopping_cart') }}</span>
            </div>
            <template v-if="cartCount()">
                <div class="purchase-wrapper">
                    <div class="text-center">
                        <span class="main-text">{{ $t('order_step3') }}</span>
                    </div>
                </div>
                <div class="alert alert-danger text-center">
                    {{ $t('please_check_informations') }}
                </div>
                <CartProducts :products="getCart()"></CartProducts>
            </template>
            <template v-else>
                <div>
                    <p class="main-text text-center mb-65">
                        {{ $t('cart_empty') }}
                    </p>
                    <p class="p-text text-center mb-5">
                        {{ $t('buy_vignette_or_bridge_fee') }}
                    </p>
                </div>
                <div class="d-md-flex justify-content-md-around">
                    <router-link :to="{name: 'vignette'}" dusk="order-vignette" type="button" class="btn btn-purple w-100 mb-4 mb-md-0">
                        {{ $t('i_want') }} {{ $tc('vignetteWord',1) }}
                    </router-link>
                    <router-link :to="{name: 'toll'}" dusk="order-vignette" type="button" class="btn btn-purple w-100">
                        {{ $t('i_want') }} {{ $tc('tollWord', 0) }}
                    </router-link>
                </div>
            </template>
            <template v-if="getCartWithErrors().length">
                <br/>
                <strong class="text-danger">{{ $t('cart_validation_errors') }}</strong>
                <CartProducts :products="getCartWithErrors()" :showDeleteBtn="false"></CartProducts>
            </template>
            <CartButtons></CartButtons>
        </div>
    </div>
</template>

<script>

import CartButtons from './CartButtons.vue'
import CartProducts from './CartProducts.vue'
import { mapGetters, mapActions } from 'vuex'
import Steps from '../snippets/Steps.vue'

export default {
    name: 'Cart',
    components: {
        CartProducts,
        CartButtons,
        Steps
    },
    props: {
    },
    methods: {

        ...mapActions('cart', [
            'removeItemFromCart'
        ]),

        ...mapGetters('cart', [
            'getCart',
            'getCartWithErrors',
            'cartCount',
            'cartTotal'
        ]),

        removeItem(index) {
            this.removeItemFromCart(index);
        },
    }
}
</script>
<style lang="scss" scoped>
    @import '../../assets/scss/_variables';

    .heading-wrapper {
        margin-top: 30px;

        .heading {
            color: $black;
        }
    }

    .p-text {
        font-size: 18px;

        font-weight: 500;
    }

    .mb-65 {
        margin-bottom: 65px;
        margin-top: 15px;
    }

    .btn-purple{
        font-size: 18px;
        padding: 11.5px 0px;

        @media only screen and (max-width: 767px) {
            width: 100%
        }

        @media only screen and (min-width: 768px) {
            max-width: 260px;
        }
    }

    .purchase-wrapper{
        margin-top: 21px;
    }
</style>
